/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { makeStyles } from 'tss-react/mui';

import { Theme } from '@mui/material/styles';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const ModuleDetailViewUseStyles = makeStyles()((theme: Theme) => ({
	detailImage: {
		maxWidth: '1200px',
		maxHeight: '800px',
		width: '100% !important',
	},
	paper: {
		maxHeight: 'calc(100% - 164px);',
		maxWidth: '815px !important',
		width: '100% !important',
	},

	header: {
		padding: '8px 32px !important',
		marginTop: `${theme.spacing(2)} !important`,
		marginBottom: `${theme.spacing(1)} !important`,
	},

	titleContainer: {
		marginTop: 'auto',
		marginBottom: 'auto',
	},

	title: {
		fontSize: '18px',
	},

	headerButtons: {
		display: 'flex',
		justifyContent: 'flex-end',
	},

	removeButton: {
		maxHeight: '35px',
		marginTop: 'auto',
		marginBottom: 'auto',
	},

	buttonLabel: {
		fontWeight: 'normal',
	},

	cancelButton: {
		padding: '0px',
		marginLeft: theme.spacing(1),
	},

	contentContainer: {
		height: '540px',
		maxHeight: '100%',
	},

	contentBox: {
		padding: theme.spacing(0, 0, 3),
		height: '100%',
	},

	contentRoot: {
		'&:first-child': {
			paddingTop: theme.spacing(1),
		},
	},

	content: {
		padding: theme.spacing(1, 2, 0, 0),
		margin: theme.spacing(0, 4, 0),
		overflowY: 'auto',
		height: '100%',
	},

	image: {
		marginTop: theme.spacing(3),
		objectFit: 'cover',
		width: '100%',
		height: '230px',
		cursor: 'pointer',
		borderRadius: '10px',
		boxShadow: '0px 0px 3px grey',
	},

	textContainer: {
		marginBottom: theme.spacing(3),
	},

	subTitle: {
		color: theme.palette.secondary.main,
		fontSize: '15px',
	},

	text: {
		fontSize: '15px',
	},
}));
